<div class="fs-2 mb-2 text-primary">
  Kontaktní údaje
</div>

<div class="mb-2">
  Shrnutí kalkulace Vám bude zasáno na zadanou emailovou adresu. V dohledné době Vás budeme kontaktovat s upřesněním nabídky.
</div>

<div class="mb-2 text-danger" *ngIf="wrongData">
  Nepodařilo se odeslat, zkontrolujte formulář
</div>

<div class="border p-3 mb-4">

  <div *ngIf="calculation">
    <div class="fw-bold mb-4">
      Identifikátor kalkulace: {{calculation.id}}
    </div>
  </div>

  <form [formGroup]="customerForm">

    <div class="mb-4">
      <label for="name" class="form-label">Jméno a příjmení *</label>
      <input id="name" class="form-control" [formControlName]="'name'" placeholder="Jméno a příjmení" type="string">
      <div *ngIf="formControls['name'].invalid && (formControls['name'].dirty || formControls['name'].touched)" class="text-danger">
        <small *ngIf="formControls['name'].errors?.['required']">Jméno a příjmení je povinné.</small>
      </div>
    </div>

    <div class="mb-4">
      <label for="email" class="form-label">Email *</label>
      <input id="email" class="form-control" [formControlName]="'email'" placeholder="Email" type="email">
      <div *ngIf="formControls['email'].invalid && (formControls['email'].dirty || formControls['email'].touched)" class="text-danger">
        <small *ngIf="formControls['email'].errors?.['required']">Email je povinný.</small>
        <small *ngIf="formControls['email'].errors?.['email']">Zadejte platný email.</small>
      </div>
    </div>

    <div class="mb-4">
      <label for="phone" class="form-label">Telefon *</label>
      <input id="phone" class="form-control" [formControlName]="'phone'" placeholder="Telefon" type="phone">
      <div *ngIf="formControls['phone'].invalid && (formControls['phone'].dirty || formControls['phone'].touched)" class="text-danger">
        <small *ngIf="formControls['phone'].errors?.['required']">Telefon je povinný.</small>
        <small *ngIf="formControls['phone'].errors?.['pattern']">Zadejte platné telefonní číslo (9-15 číslic).</small>
      </div>
    </div>

  </form>

</div>

<div class="d-grid">
  <button class="btn btn-lg w-full rounded-pill btn-primary btn-block" (click)="onSubmit()" [disabled]="!customerForm.valid">Odeslat</button>
</div>
